import { EventEmitter, ViewChild} from '@angular/core';
import { ContactUsSubject, NotifyType } from '../contact_us_subject-types';
import { Component, Input, Output, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ContactUsSubjectFormsService } from '../services/contact-us-subject-forms.service';

@Component({
  selector: 'subject-dialog',
  templateUrl: './subject-dialog.component.html',
})
export class SubjectDialogComponent implements OnInit {

  dialogOpen = false;
  form: UntypedFormGroup;

  subject: ContactUsSubject;

  @Input() notifyTypes: NotifyType[];

  @Output() onSave = new EventEmitter<ContactUsSubject>();

  constructor( private formService: ContactUsSubjectFormsService ) { }

  ngOnInit(): void {
    this.setupForm();
  }

  private setupForm() {
    this.subject = {
      Uri: undefined,
      Subject: '',
      NotifyType: this.notifyTypes && this.notifyTypes.length > 0 ? this.notifyTypes[0].Value : '',
      Emails: []
    };
    this.form = this.formService.setupContactUsSubjectForm(this.subject);
  }

  showAddNewSubjectDialog() {
    this.setupForm();
    this.dialogOpen = true;
  }

  cancel() {
    this.dialogOpen  = false;
  }

  save() {
    this.formService.mapFormToSubject(this.form, this.subject);
    this.onSave.emit(this.subject);
    this.dialogOpen  = false;
  }
  //will be used later in a different ticket
  //onKeyDown(event) {
  //  if (event.key === ";") {
  //    // use the internal method to set the new value
  //    this.form.controls['emails'].setValue([...this.form.controls['emails'].value, event.target.value]);
      
  //    event.target.value = "";   // reset the input value
  //    event.preventDefault();    //prevent ';' to be written

  //    this.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  //  }
  //}
}
